export function availabilityRank(stock: number) {
  if (stock <= 0) return 100;
  return stock;
}
